import { initCarousel } from '@/braun/Controllers/BraunCarouselController';

export const initVariablesSlide = () => {
  const variablesSlide = document.getElementsByClassName(
    'bra-product-details__variableSlides',
  )[0];

  if (variablesSlide)
    initCarousel(
      variablesSlide,
      {
        slidesPerViewXl: 'auto',
        slidesPerViewL: 'auto',
        slidesPerViewM: 'auto',
        slidesPerViewXs: 'auto',

        spaceBetweenXl: 10,
        spaceBetweenL: 10,
        spaceBetweenM: 10,
        spaceBetweenXs: 10,

        hideScrollbar: false,
      },
      {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        roundLengths: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
      },
    );
};

export default () => {
  initVariablesSlide();
};
